import { AmplitudeEventTypes } from '../integrations/amplitude/types'

// TODO: This is only here so we don't have to update all the existing imports
export const TrackingEvent = AmplitudeEventTypes

export type LogEvent = (eventType: string, eventProperties?: object) => void
